// React
import React from "react";
// Redux
import { connect } from "react-redux";
// Ducks
import { navigateTo } from "../../../../Dashboard.ducks";

const Logo = ({ logo, navigateTo }) => (
  <div id="logo-group">
    <span
      id="logo"
      onClick={() => navigateTo("/dashboard")}
      style={{
        alignItems: "flex-start",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        margin: 0,
        marginLeft: "5%"
      }}
    >
      <img alt="LPLUS Register" src={logo} style={{ height: 35, width: "auto" }} />
    </span>
  </div>
);

export default connect(
  null,
  { navigateTo }
)(Logo);
